import { create } from 'zustand';

interface ProductsState {
  selectedCategoryId: string | null;
  currentPage: number;
  setSelectedCategoryId: (categoryId: string | null) => void;
  setCurrentPage: (page: number) => void;
  resetFilters: () => void;
}

export const useProductsStore = create<ProductsState>((set) => ({
  selectedCategoryId: null,
  currentPage: 1,
  setSelectedCategoryId: (categoryId) => set({ selectedCategoryId: categoryId, currentPage: 1 }),
  setCurrentPage: (page) => set({ currentPage: page }),
  resetFilters: () => set({ selectedCategoryId: null, currentPage: 1 }),
}));
